<template>
  <div class="content-wrapper">
    <div class="bg-content"></div>
    <div class="relative content-cards">
      <DetailCard class="credit-input-card">
        <template #title>クレジットカードのご登録・決済</template>
        <template #content>
          <slot name="inputs" />
        </template>
      </DetailCard>
    </div>
  </div>
</template>

<script>
import DetailCard from './DetailCard';

export default {
  components: {
    DetailCard,
  },
};
</script>

<style scoped>
.content-wrapper {
  position: relative;
  overflow: hidden;
  margin-top: 224px;
  padding: 270px 0;
}
.bg-content {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 200vw;
  left: -50vw;
  border-top-right-radius: 50%;
  border-top-left-radius: 50%;
  background-image: url('/img/lp/patterns/slashLight.png');
  background-repeat: repeat;
  border-top: solid rgb(242, 231, 202) 8px;
}
.content-cards {
  padding: 0 10%;
}
.credit-input-card {
  margin-top: 150px;
}
@media (max-width: 767px) {
  .content-cards {
    padding: 0 20px;
  }
  .content-wrapper {
    margin-top: 60px;
    padding: 60px 0 40px;
  }
  .bg-content {
    width: 400vw;
    left: -150vw;
  }
  .credit-input-card {
    margin-top: 50px;
  }
}
</style>
